import React from 'react'
import CookieBanner from './CookieBanner'

const Layout = ({ children }) => {
  return (
    <>
      {children}
      <CookieBanner />
    </>
  )
}

export default Layout
